import request from '@/utils/http';

export const addConfig = (data) => {
    return request({
        url: '/api-antms/billing/billingAdvance/riskConfig/insert',
        method: 'post',
        data
    });
};

export const updateConfig = (data) => {
    return request({
        url: `/api-antms/billing/billingAdvance/riskConfig/update`,
        method: 'post',
        data
    });
};

export const batchDelete = (data) => {
    return request({
        url: `/api-antms/billing/billingAdvance/riskConfig/batchDelete`,
        method: 'post',
        data
    });
};

export const queryRiskConfigPage = (data) => {
    return request({
        url: `/api-antms/billing/billingAdvance/riskConfig/queryRiskConfigPage`,
        method: 'post',
        data
    });
};

export const queryTotal = (data) => {
    return request({
        url: `/api-antms/billing/billingAdvance/riskConfig/queryTotal`,
        method: 'post',
        data
    });
};
